import type { EventSink } from '../events'
import type { ItemId, World } from '../world'
import { boostJet } from './boost_jet'
import { homingDrone } from './homing_drone'
import { leaderMissile } from './leader_missile'
import { magnet } from './magnet'
import { oilSlick } from './oil_slick'
import { shieldBubble } from './shield_bubble'
import { spikeBall } from './spike_ball'
import { tripWire } from './trip_wire'
import type { ItemDef } from './types'

/** Item id → behaviour. Looked up by key, never iterated. */
const ITEMS: { readonly [K in ItemId]: ItemDef } = {
  boost_jet: boostJet,
  shield_bubble: shieldBubble,
  trip_wire: tripWire,
  spike_ball: spikeBall,
  homing_drone: homingDrone,
  oil_slick: oilSlick,
  leader_missile: leaderMissile,
  magnet,
}

/**
 * Step 7: by player index, an ITEM press edge (`presses[i]`, from the effective step-1 bits, so
 * never while stunned, finished or respawning) uses the held item when the cooldown is over and
 * the player was not stunned earlier this tick.
 */
export function stepItemUse(world: World, presses: readonly boolean[], events: EventSink): void {
  const { tick } = world
  for (let i = 0; i < world.players.length; i++) {
    const p = world.players[i]!
    const item = p.item
    const helpless = p.stunnedUntil > tick || p.skidUntil > tick
    if (!presses[i] || item === null || tick < p.itemCooldownUntil || helpless) {
      continue
    }
    p.item = null
    p.itemCooldownUntil = tick + world.cfg.items.itemCooldownTicks
    events.push({ type: 'itemUsed', tick, player: i, item })
    ITEMS[item].use(world, i, events)
  }
}
